import Loadable from 'react-loadable';
import PageLoading from '@/account/pages/PageLoading';

export const ProductRegistrationSearchLazy = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "pr-search" */ '@/product-registration/pages/ProductRegistrationSearch'
    ),
  loading: PageLoading,
});

export const ProductRegistrationSelectLazy = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "pr-select" */ '@/product-registration/pages/ProductRegistrationSelect'
    ),
  loading: PageLoading,
});

export const ProductRegistrationUserDetailLazy = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "pr-detail" */ '@/product-registration/pages/user-detail/ProductRegistrationUserDetail'
    ),
  loading: PageLoading,
});

export const ProductRegistrationDetailLazy = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "pr-detail" */ '@/product-registration/pages/detail/ProductRegistrationDetail'
    ),
  loading: PageLoading,
});

export const ProductRegistrationConfirmationLazy = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "pr-confirmation" */ '@/product-registration/pages/ProductRegistrationConfirmation'
    ),
  loading: PageLoading,
});
